import styled from "@emotion/styled";

export const PanelControls = styled.div`
  display: flex;
  gap: 4px;

  padding-inline: 4px;
  border-inline-end: 1px solid ${({ theme }) => theme.surfaceBack_1};
`;
